import * as fromDatatype from "../datatype-library/index";

export interface bl_inv_txn_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_txn_hdr: fromDatatype.GuidDataFieldInterface;
  guid_generic_doc_line: fromDatatype.GuidDataFieldInterface;
  guid_fi_mst_item: fromDatatype.GuidDataFieldInterface;
  guid_bl_fi_mst_comp: fromDatatype.GuidDataFieldInterface;
  guid_bl_fi_mst_branch: fromDatatype.GuidDataFieldInterface;
  guid_bl_inv_mst_location: fromDatatype.GuidDataFieldInterface;
  guid_bl_fi_mst_entity_hdr: fromDatatype.GuidDataFieldInterface;
  guid_bl_fi_mst_entity_line: fromDatatype.GuidDataFieldInterface;
  guid_store: fromDatatype.GuidDataFieldInterface;
  guid_profit_center: fromDatatype.GuidDataFieldInterface;
  guid_segment: fromDatatype.GuidDataFieldInterface;
  guid_project: fromDatatype.GuidDataFieldInterface;
  guid_dimension: fromDatatype.GuidDataFieldInterface;
  guid_glcode: fromDatatype.GuidDataFieldInterface;
  label_json: fromDatatype.JsonDatatypeInterface;
  foreign_ccy: fromDatatype.CurrencyCodeDataFieldInterface;
  base_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  base_doc_line_ccy: fromDatatype.CurrencyCodeDataFieldInterface;
  base_doc_line_xrate: fromDatatype.NumericDatatypeInterface;
  doc_ccy: fromDatatype.CurrencyCodeDataFieldInterface;
  amount_cogs: fromDatatype.MoneyDatatypeInterface;
  amount_std: fromDatatype.MoneyDatatypeInterface;
  amount_discount: fromDatatype.MoneyDatatypeInterface;
  amount_net: fromDatatype.MoneyDatatypeInterface;
  tax_gst_code: fromDatatype.VarcharDatatypeInterface;
  tax_gst_type: fromDatatype.VarcharDatatypeInterface;
  tax_gst_rate: fromDatatype.NumericDatatypeInterface;
  amount_tax_gst: fromDatatype.MoneyDatatypeInterface;
  tax_wht_type: fromDatatype.VarcharDatatypeInterface;
  tax_wht_code: fromDatatype.VarcharDatatypeInterface;
  tax_wht_rate: fromDatatype.NumericDatatypeInterface;
  amount_tax_wht: fromDatatype.MoneyDatatypeInterface;
  amount_txn: fromDatatype.MoneyDatatypeInterface;
  amount_json: fromDatatype.JsonDatatypeInterface;
  amount_open_balance: fromDatatype.MoneyDatatypeInterface;
  amount_signum: fromDatatype.MoneyDatatypeInterface;
  item_guid: fromDatatype.GuidDataFieldInterface;
  item_code: fromDatatype.VarcharDatatypeInterface;
  item_machine_code: fromDatatype.VarcharDatatypeInterface;
  item_name: fromDatatype.TextDatatypeInterface;
  item_desc: fromDatatype.TextDatatypeInterface;
  item_remarks: fromDatatype.TextDatatypeInterface;
  item_reference_no: fromDatatype.TextDatatypeInterface;
  pseudo_item_code: fromDatatype.VarcharDatatypeInterface;
  pseudo_item_name: fromDatatype.TextDatatypeInterface;
  pseudo_item_description: fromDatatype.TextDatatypeInterface;
  item_custom_template_json: fromDatatype.JsonDatatypeInterface;
  item_custom_data_json: fromDatatype.JsonDatatypeInterface;
  item_property_json: fromDatatype.JsonDatatypeInterface;
  item_child_json: fromDatatype.JsonDatatypeInterface;
  item_to_item_link_json: fromDatatype.JsonDatatypeInterface;
  sort_code: fromDatatype.VarcharDatatypeInterface;
  line_option_json: fromDatatype.JsonDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  txn_code: fromDatatype.VarcharDatatypeInterface;
  reference_no: fromDatatype.VarcharDatatypeInterface;
  quantity_signum: fromDatatype.NumericDatatypeInterface;
  quantity_base: fromDatatype.NumericDatatypeInterface;
  position_id: fromDatatype.VarcharDatatypeInterface;
  uom_json: fromDatatype.JsonDatatypeInterface;
  line_property_json: fromDatatype.JsonDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  txn_date: fromDatatype.TimestampTzDatatypeInterface;
  txn_created: fromDatatype.TimestampTzDatatypeInterface;
  txn_updated: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.TimestampTzDatatypeInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  pic1_guid: fromDatatype.GuidDataFieldInterface;
  pic1_code: fromDatatype.VarcharDatatypeInterface;
  pic1_table: fromDatatype.VarcharDatatypeInterface;
  pic1_type: fromDatatype.VarcharDatatypeInterface;
  pic2_guid: fromDatatype.GuidDataFieldInterface;
  pic2_code: fromDatatype.VarcharDatatypeInterface;
  pic2_table: fromDatatype.VarcharDatatypeInterface;
  pic2_type: fromDatatype.VarcharDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_source: fromDatatype.VarcharDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  guid_generic_doc_hdr: fromDatatype.GuidDataFieldInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  serial_no_json: fromDatatype.JsonDatatypeInterface;
  batch_no_json: fromDatatype.JsonDatatypeInterface;
  bin_no_json: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  cost_ma_amount: fromDatatype.NumericDatatypeInterface;
  cost_ma_price: fromDatatype.NumericDatatypeInterface;
  cost_wa_amount: fromDatatype.NumericDatatypeInterface;
  cost_wa_price: fromDatatype.NumericDatatypeInterface;
  cost_fifo_amount: fromDatatype.NumericDatatypeInterface;
  cost_fifo_price: fromDatatype.NumericDatatypeInterface;
  cost_lifo_amount: fromDatatype.NumericDatatypeInterface;
  cost_lifo_price: fromDatatype.NumericDatatypeInterface;
  cost_manual_amount: fromDatatype.NumericDatatypeInterface;
  cost_manual_price: fromDatatype.NumericDatatypeInterface;
  cost_replacement_amount: fromDatatype.NumericDatatypeInterface;
  cost_replacement_price: fromDatatype.NumericDatatypeInterface;
  cost_last_purchase_location: fromDatatype.NumericDatatypeInterface;
  cost_last_purchase_company: fromDatatype.NumericDatatypeInterface;
  unit_price_net: fromDatatype.NumericDatatypeInterface;
  server_doc_1: fromDatatype.VarcharDatatypeInterface;
  server_doc_2: fromDatatype.VarcharDatatypeInterface;
  server_doc_3: fromDatatype.VarcharDatatypeInterface;
  server_doc_4: fromDatatype.VarcharDatatypeInterface;
  server_doc_5: fromDatatype.VarcharDatatypeInterface;
  client_doc_1: fromDatatype.VarcharDatatypeInterface;
  client_doc_2: fromDatatype.VarcharDatatypeInterface;
  client_doc_3: fromDatatype.VarcharDatatypeInterface;
  client_doc_4: fromDatatype.VarcharDatatypeInterface;
  client_doc_5: fromDatatype.VarcharDatatypeInterface;
  bal_qty: fromDatatype.NumericDatatypeInterface;
  txn_location_running_no: fromDatatype.VarcharDatatypeInterface;
  txn_company_running_no: fromDatatype.VarcharDatatypeInterface;
  landed_txn_amount: fromDatatype.NumericDatatypeInterface;
  landed_txn_price: fromDatatype.NumericDatatypeInterface;
  landed_cost_ma_price: fromDatatype.NumericDatatypeInterface;
  landed_cost_ma_amount: fromDatatype.NumericDatatypeInterface;
  landed_cost_wa_amount: fromDatatype.NumericDatatypeInterface;
  landed_cost_wa_price: fromDatatype.NumericDatatypeInterface;
  landed_cost_fifo_amount: fromDatatype.NumericDatatypeInterface;
  landed_cost_fifo_price: fromDatatype.NumericDatatypeInterface;
  landed_cost_lifo_amount: fromDatatype.NumericDatatypeInterface;
  landed_cost_lifo_price: fromDatatype.NumericDatatypeInterface;
  prev_location_txn_guid: fromDatatype.GuidDataFieldInterface;
  next_location_txn_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_inv_txn_line_RowClass implements bl_inv_txn_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_txn_hdr: fromDatatype.GuidDataFieldInterface;
  guid_generic_doc_line: fromDatatype.GuidDataFieldInterface;
  guid_fi_mst_item: fromDatatype.GuidDataFieldInterface;
  guid_bl_fi_mst_comp: fromDatatype.GuidDataFieldInterface;
  guid_bl_fi_mst_branch: fromDatatype.GuidDataFieldInterface;
  guid_bl_inv_mst_location: fromDatatype.GuidDataFieldInterface;
  guid_bl_fi_mst_entity_hdr: fromDatatype.GuidDataFieldInterface;
  guid_bl_fi_mst_entity_line: fromDatatype.GuidDataFieldInterface;
  guid_store: fromDatatype.GuidDataFieldInterface;
  guid_profit_center: fromDatatype.GuidDataFieldInterface;
  guid_segment: fromDatatype.GuidDataFieldInterface;
  guid_project: fromDatatype.GuidDataFieldInterface;
  guid_dimension: fromDatatype.GuidDataFieldInterface;
  guid_glcode: fromDatatype.GuidDataFieldInterface;
  label_json: fromDatatype.JsonDatatypeInterface;
  foreign_ccy: fromDatatype.CurrencyCodeDataFieldInterface;
  base_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  base_doc_line_ccy: fromDatatype.CurrencyCodeDataFieldInterface;
  base_doc_line_xrate: fromDatatype.NumericDatatypeInterface;
  doc_ccy: fromDatatype.CurrencyCodeDataFieldInterface;
  amount_cogs: fromDatatype.MoneyDatatypeInterface;
  amount_std: fromDatatype.MoneyDatatypeInterface;
  amount_discount: fromDatatype.MoneyDatatypeInterface;
  amount_net: fromDatatype.MoneyDatatypeInterface;
  tax_gst_code: fromDatatype.VarcharDatatypeInterface;
  tax_gst_type: fromDatatype.VarcharDatatypeInterface;
  tax_gst_rate: fromDatatype.NumericDatatypeInterface;
  amount_tax_gst: fromDatatype.MoneyDatatypeInterface;
  tax_wht_type: fromDatatype.VarcharDatatypeInterface;
  tax_wht_code: fromDatatype.VarcharDatatypeInterface;
  tax_wht_rate: fromDatatype.NumericDatatypeInterface;
  amount_tax_wht: fromDatatype.MoneyDatatypeInterface;
  amount_txn: fromDatatype.MoneyDatatypeInterface;
  amount_json: fromDatatype.JsonDatatypeInterface;
  amount_open_balance: fromDatatype.MoneyDatatypeInterface;
  amount_signum: fromDatatype.MoneyDatatypeInterface;
  item_guid: fromDatatype.GuidDataFieldInterface;
  item_code: fromDatatype.VarcharDatatypeInterface;
  item_machine_code: fromDatatype.VarcharDatatypeInterface;
  item_name: fromDatatype.TextDatatypeInterface;
  item_desc: fromDatatype.TextDatatypeInterface;
  item_remarks: fromDatatype.TextDatatypeInterface;
  item_reference_no: fromDatatype.TextDatatypeInterface;
  pseudo_item_code: fromDatatype.VarcharDatatypeInterface;
  pseudo_item_name: fromDatatype.TextDatatypeInterface;
  pseudo_item_description: fromDatatype.TextDatatypeInterface;
  item_custom_template_json: fromDatatype.JsonDatatypeInterface;
  item_custom_data_json: fromDatatype.JsonDatatypeInterface;
  item_property_json: fromDatatype.JsonDatatypeInterface;
  item_child_json: fromDatatype.JsonDatatypeInterface;
  item_to_item_link_json: fromDatatype.JsonDatatypeInterface;
  sort_code: fromDatatype.VarcharDatatypeInterface;
  line_option_json: fromDatatype.JsonDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  txn_code: fromDatatype.VarcharDatatypeInterface;
  reference_no: fromDatatype.VarcharDatatypeInterface;
  quantity_signum: fromDatatype.NumericDatatypeInterface;
  quantity_base: fromDatatype.NumericDatatypeInterface;
  position_id: fromDatatype.VarcharDatatypeInterface;
  uom_json: fromDatatype.JsonDatatypeInterface;
  line_property_json: fromDatatype.JsonDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  txn_date: fromDatatype.TimestampTzDatatypeInterface;
  txn_created: fromDatatype.TimestampTzDatatypeInterface;
  txn_updated: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.TimestampTzDatatypeInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  pic1_guid: fromDatatype.GuidDataFieldInterface;
  pic1_code: fromDatatype.VarcharDatatypeInterface;
  pic1_table: fromDatatype.VarcharDatatypeInterface;
  pic1_type: fromDatatype.VarcharDatatypeInterface;
  pic2_guid: fromDatatype.GuidDataFieldInterface;
  pic2_code: fromDatatype.VarcharDatatypeInterface;
  pic2_table: fromDatatype.VarcharDatatypeInterface;
  pic2_type: fromDatatype.VarcharDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_source: fromDatatype.VarcharDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  guid_generic_doc_hdr: fromDatatype.GuidDataFieldInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  serial_no_json: fromDatatype.JsonDatatypeInterface;
  batch_no_json: fromDatatype.JsonDatatypeInterface;
  bin_no_json: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  cost_ma_amount: fromDatatype.NumericDatatypeInterface;
  cost_ma_price: fromDatatype.NumericDatatypeInterface;
  cost_wa_amount: fromDatatype.NumericDatatypeInterface;
  cost_wa_price: fromDatatype.NumericDatatypeInterface;
  cost_fifo_amount: fromDatatype.NumericDatatypeInterface;
  cost_fifo_price: fromDatatype.NumericDatatypeInterface;
  cost_lifo_amount: fromDatatype.NumericDatatypeInterface;
  cost_lifo_price: fromDatatype.NumericDatatypeInterface;
  cost_manual_amount: fromDatatype.NumericDatatypeInterface;
  cost_manual_price: fromDatatype.NumericDatatypeInterface;
  cost_replacement_amount: fromDatatype.NumericDatatypeInterface;
  cost_replacement_price: fromDatatype.NumericDatatypeInterface;
  cost_last_purchase_location: fromDatatype.NumericDatatypeInterface;
  cost_last_purchase_company: fromDatatype.NumericDatatypeInterface;
  unit_price_net: fromDatatype.NumericDatatypeInterface;
  server_doc_1: fromDatatype.VarcharDatatypeInterface;
  server_doc_2: fromDatatype.VarcharDatatypeInterface;
  server_doc_3: fromDatatype.VarcharDatatypeInterface;
  server_doc_4: fromDatatype.VarcharDatatypeInterface;
  server_doc_5: fromDatatype.VarcharDatatypeInterface;
  client_doc_1: fromDatatype.VarcharDatatypeInterface;
  client_doc_2: fromDatatype.VarcharDatatypeInterface;
  client_doc_3: fromDatatype.VarcharDatatypeInterface;
  client_doc_4: fromDatatype.VarcharDatatypeInterface;
  client_doc_5: fromDatatype.VarcharDatatypeInterface;
  bal_qty: fromDatatype.NumericDatatypeInterface;
  txn_location_running_no: fromDatatype.VarcharDatatypeInterface;
  txn_company_running_no: fromDatatype.VarcharDatatypeInterface;
  landed_txn_amount: fromDatatype.NumericDatatypeInterface;
  landed_txn_price: fromDatatype.NumericDatatypeInterface;
  landed_cost_ma_price: fromDatatype.NumericDatatypeInterface;
  landed_cost_ma_amount: fromDatatype.NumericDatatypeInterface;
  landed_cost_wa_amount: fromDatatype.NumericDatatypeInterface;
  landed_cost_wa_price: fromDatatype.NumericDatatypeInterface;
  landed_cost_fifo_amount: fromDatatype.NumericDatatypeInterface;
  landed_cost_fifo_price: fromDatatype.NumericDatatypeInterface;
  landed_cost_lifo_amount: fromDatatype.NumericDatatypeInterface;
  landed_cost_lifo_price: fromDatatype.NumericDatatypeInterface;
  prev_location_txn_guid: fromDatatype.GuidDataFieldInterface;
  next_location_txn_guid: fromDatatype.GuidDataFieldInterface;
}
